/**
 * Sets that have a page of their own. A companion set (pageWith: host) is shown as a
 * second grid on its host's page, so it gets no tab and is never the default.
 */
export function pageSets(sets) {
  return (sets || []).filter(s => s.set && !s.pageWith);
}

/**
 * The set /sets opens on: the next set to release (soonest upcoming release date),
 * or, once everything has released, the most recently released one.
 */
export function pickDefaultSet(sets, today = new Date().toISOString().slice(0, 10)) {
  const dated = pageSets(sets);
  const upcoming = dated
    .filter(s => (s.releaseDate || '9999') >= today)
    .sort((a, b) => (a.releaseDate || '9999').localeCompare(b.releaseDate || '9999'));
  if (upcoming.length) return upcoming[0].set;
  const released = [...dated].sort((a, b) => (b.releaseDate || '').localeCompare(a.releaseDate || ''));
  return released[0]?.set || null;
}
